export const CHECK_MOBILE = '@@mobileDetector/checkMobile'
export const CHECK_TABLET = '@@mobileDetector/checkTablet'
